import { AvatarSex, ISmplPose } from '@seddi/avatar';
import { getAuthToken } from '../auth';
import { VTO_GARMENTS_ADDRESS } from '../constants';
import { GarmentExt } from './garmentTypes';
import { Style } from './styleTypes';
import { fetchPoses } from '../avatars';

export type VtoSizeRecommendation = {
  size: string;
};

/**
 * Get garment from ID.
 * @param id Garment ID.
 */
export const fetchGarment = async (id: string): Promise<GarmentExt> => {
  const idToken = await getAuthToken();
  const headers = {
    ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    'Content-Type': 'application/json',
  };

  const response = await fetch(`${VTO_GARMENTS_ADDRESS}/v1/garments/${id}`, {
    headers,
  });

  const { status } = response;
  if (status < 200 || status >= 400) {
    throw new Error();
  }

  const garment = (await response.json()) as GarmentExt;
  return garment;
};

/**
 * Get style from ID.
 * @param id Style ID.
 */
export const fetchStyle = async (id: string): Promise<Style> => {
  const idToken = await getAuthToken();
  const headers = {
    ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    'Content-Type': 'application/json',
  };

  const response = await fetch(`${VTO_GARMENTS_ADDRESS}/v1/styles/${id}`, {
    headers,
  });

  const { status } = response;
  if (status < 200 || status >= 400) {
    throw new Error();
  }

  const style = (await response.json()) as Style;
  return style;
};

// Poses are static for now, take advantage of it.
let gPoses: ISmplPose[] | undefined;

/**
 * Get style poses from ID.
 * @param id Style ID.
 */
export const fetchStylePoses = async (_: string): Promise<ISmplPose[]> => {
  if (!gPoses) {
    gPoses = await fetchPoses();
  }
  return gPoses;
};

/**
 * Get style size recommendation.
 * @param id Style ID.
 * @param avatarSex Avatar sex.
 * @param avatarSmplShape Avatar shape.
 * @param variant Style variant.
 */
export const fetchStyleSizeRecommendation = async (
  id: string,
  avatarSex: AvatarSex,
  avatarSmplShape: number[],
  variant: string,
): Promise<VtoSizeRecommendation> => {
  const idToken = await getAuthToken();
  const headers = {
    ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    'Content-Type': 'application/json',
  };

  const body = JSON.stringify({ avatarSex, avatarSmplShape, variant });

  const response = await fetch(`${VTO_GARMENTS_ADDRESS}/v1/styles/${id}/size-recommendation`, {
    body,
    headers,
    method: 'POST',
  });

  const { status } = response;
  if (status < 200 || status >= 400) {
    throw new Error();
  }

  const dto = (await response.json()) as VtoSizeRecommendation;
  return dto;
};
